import moment from 'moment';
import blackDownArrow from "../../../common/icons/svg/black-down-arrow.svg";
import blackUpArrow from "../../../common/icons/svg/black-up-arrow.svg";
import whiteUpArrow from "../../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../../common/icons/svg/white-down-arrow.svg";
import './DeviceTabMobileView.scss'

function DeviceTabDesktopView({
    deviceAlarmData,
    showMoreAlarms_1,
    handleShowMoreAlarmsClick_1,
    handleSeeAllAlarms,
    getAlarmPriorityClass
}) {
    return (
        <div className='machine-tabs-wrap-mobile-view'>
            {deviceAlarmData?.length > 0 &&
                <div
                    className={`alarm-container ${getAlarmPriorityClass(deviceAlarmData[0])}`}
                    onClick={handleShowMoreAlarmsClick_1}
                    id="alarm-display-bar-1"
                >
                    <div className="top-alarm-container">
                        {deviceAlarmData[0]?.name}

                        <div className="alarm-number-container">
                            {deviceAlarmData?.length}
                            <img
                                // style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                src={
                                    showMoreAlarms_1
                                        ? (deviceAlarmData[0]?.priority?.toLocaleUpperCase() === "HIGH"
                                            ? whiteUpArrow : blackUpArrow)
                                        : (deviceAlarmData[0]?.priority?.toLocaleUpperCase() === "HIGH"
                                            ? whiteDownArrow : blackDownArrow)
                                }
                                className="arrow-icon"
                                alt="accordion arrow"
                            />
                        </div>
                    </div>

                    {showMoreAlarms_1 &&
                        <div className="more-alarm-container">
                            {deviceAlarmData.map((alarm, count) => {
                                if (count > 3) return null;
                                return (
                                    <div className="alarm more-alarm" key={count}>
                                        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            <img
                                                src={`/assets/icons/alarm/${getAlarmPriorityClass(alarm)}-alarm.png`}
                                                style={{ width: '20px', height: '20px', marginRight: '10px' }}
                                                alt="alarm icon"
                                            />
                                            {alarm.name}
                                        </div>
                                        <span className="alarm-time">
                                            {alarm.time && moment(alarm.time, "YYYYMMDDHHmmss").format("HH:mm:ss")}
                                        </span>
                                    </div>
                                );
                            })}

                            <div className="see-all-container" onClick={handleSeeAllAlarms}>
                                See all
                            </div>
                        </div>
                    }
                </div>

            }
        </div>
    );
}

export default DeviceTabDesktopView;
